import { MenuItem } from './menu.model';
import { getUserManagementMenu, UserContext } from '../../../common';
import { TranslateService } from '@ngx-translate/core';
import { getCompanyManagementMenu } from '../../../company-management/common';
import { getDeliveryInstructionManagementMenu } from '../../../delivery-instruction-management/common';
import { getStatusMappingManagementMenu } from '../../../configurations/status-mapping-management/common';
import { getWorkflowsMenu } from '../../../workflows/common';
import { getNationalAddressFinderMenu } from '../../../national-address-finder/common/menu/national-address-finder.menu';

export const getMenu: (userContext?: UserContext, translate?: TranslateService) => MenuItem[] = (
  userContext?: UserContext,
  translate?: TranslateService
) => {
  return [
    ...getUserManagementMenu(userContext, translate),
    ...getCompanyManagementMenu(userContext, translate),
    ...getDeliveryInstructionManagementMenu(userContext, translate),
    ...getStatusMappingManagementMenu(userContext, translate),
    ...getWorkflowsMenu(userContext, translate),
    ...getNationalAddressFinderMenu(userContext, translate)
  ];
};
